
import { useEffect, useState } from 'react'
import DataTableLayer from '../../components/DataTableLayer'
import PostByAgg from '../../utils/axios'
import ModalAlert from '../../components/ModalAlert'
import LottieLoading from '../../components/child/LottieLoading'

const Bank = () => {
    const [listBank, setListBank] = useState([])
    const [isLoading, setIsLoading] = useState (true)
    const [modalOpen,setModalOpen] = useState(<div></div>)

    const columns = [
        {
            accessorKey: "bank_code",
            header: "Kode Bank",
        },
        {
            accessorKey: "bank_name",
            header: "Nama Bank",
        }
    ];

    const ListBank = () => {
        setIsLoading(true)
        const url ='label/lm/v1/bank/find-by-name';
        PostByAgg({
            url:url,
            body:{
                "bank_name":""
            },
            onResponse: onResponseListBank,
            onError: onErrorListBank
        })
    }

    const onResponseListBank = (response) => {
        console.log("list bank",response.data.data)
        if(response.data.code === '2002000' || response.data.data === null){
            setIsLoading(false)
            setListBank(response.data?.data || [])
        }else{
            setIsLoading(false)
            setListBank([])
        }
    }

    const onErrorListBank = (error) => {
        console.log(error)
        setIsLoading(false)
        setModalOpen(
            <ModalAlert
                show={true}
                type={"failed"}
                text={error.response.data}
                action={()=>{}}
            />
        )

    }

    useEffect (()=>{
        ListBank()
    },[])

  return (
    <div>
        <DataTableLayer 
        title={"Bank Table"}
        data={listBank}
        columns={columns}
        showButton={false}
        />
        {modalOpen}
        {isLoading && <LottieLoading text='Loading...'/>}
    </div>
  )
}

export default Bank